import React from 'react';

const IconRefresh = props => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.467 12.3618C21.1536 12.3072 20.8312 12.3793 20.5709 12.5624C20.3107 12.7454 20.1337 13.0243 20.079 13.3378C19.7677 15.1266 18.8341 16.7477 17.4432 17.9148C16.0523 19.0819 14.2937 19.7198 12.478 19.7158C8.22404 19.7158 4.76304 16.2548 4.76304 11.9998C4.76304 7.74577 8.22404 4.28477 12.478 4.28477C14.412 4.28477 16.231 4.99877 17.653 6.28877L16.661 7.28077C16.5313 7.41006 16.4399 7.57281 16.3971 7.75093C16.3543 7.92905 16.3618 8.11555 16.4187 8.28967C16.4756 8.46379 16.5797 8.61872 16.7194 8.7372C16.8591 8.85568 17.029 8.93308 17.21 8.96077L21.422 9.61077C21.5759 9.63449 21.7332 9.62159 21.8812 9.57311C22.0291 9.52462 22.1635 9.44193 22.2735 9.33175C22.3835 9.22156 22.466 9.08699 22.5142 8.93895C22.5624 8.79092 22.575 8.6336 22.551 8.47977L21.902 4.26877C21.8742 4.08782 21.7967 3.91812 21.6782 3.77852C21.5598 3.63891 21.4049 3.53485 21.2309 3.47789C21.0569 3.42092 20.8705 3.41327 20.6924 3.45579C20.5144 3.49831 20.3515 3.58934 20.222 3.71877L19.35 4.59177C17.4863 2.84939 15.0294 1.88156 12.478 1.88477C6.90104 1.88477 2.36304 6.42277 2.36304 11.9998C2.36304 17.5778 6.90104 22.1148 12.478 22.1148C17.406 22.1148 21.596 18.5968 22.443 13.7498C22.4976 13.4363 22.4255 13.114 22.2424 12.8537C22.0594 12.5934 21.7805 12.4165 21.467 12.3618Z"
        fill="currentColor"
      />
    </svg>
  );
};

const MemoIconRefresh = React.memo(IconRefresh);
export default MemoIconRefresh;
